var DialogApprovalsEquipmentsModule = /** @class */ (function () {
    function DialogApprovalsEquipmentsModule() {
    }
    return DialogApprovalsEquipmentsModule;
}());
export { DialogApprovalsEquipmentsModule };
